
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddPrioridadTarea (){
    const { tienePermiso } = useAccesos();

    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
        <h2>Prioridad de Tarea</h2>
        <br />
        <form id="formEtnia" className="form-horizontal form-label-left" >
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionPrioridad">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionEtnia"
                        required="required"
                        className="form-control"
                        value=""
                    />
                </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Prioridad Tarea')}> Guardar
                        {/* {editEtnia ? 'Actualizar' : 'Guardar'} */}
                    </button>
                </div>
            </div>
        </form>
    </>
    )
}


export default AddPrioridadTarea;